import { useMutation } from '@tanstack/react-query'

import { createInquiry } from '@flecto/api/store'
import { type CoreInquiryPayload } from '@flecto/types'

type MutationPayload = {
  storeDomain?: string
  inquiry: CoreInquiryPayload
}

export function useMutationCreateInquiry() {
  return useMutation({
    mutationKey: ['MutationCreateInquiry'],
    mutationFn: async ({ storeDomain, inquiry }: MutationPayload) =>
      await createInquiry(storeDomain ?? '', inquiry),
  })
}
